import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { faCircleCheck, faCircleMinus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { Observable, finalize } from 'rxjs';
import { CompanyDebtorMinuteRequestResolutionDTO } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-detail';
import { CompanyDebtorMinuteResolutionDTO } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-request.interface';
import { MinuteRequestService } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/service/minute-request.service';

@Component({
  selector: 'app-debtors-minute',
  templateUrl: './debtors-minute.component.html',
  styleUrls: ['./debtors-minute.component.scss']
})
export class DebtorsMinuteComponent {
  //Input para recibir todas las resoluciones de deudores de minuta
  @Input() minuteDebtorResolutions: Array<CompanyDebtorMinuteRequestResolutionDTO>;
  @Input() minuteRequestId: number;
  @Input() canChangeResolution: boolean;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true}) paginator: MatPaginator;
  public loadingDebtors: Array<number> = [];
  public dataSource: MatTableDataSource<CompanyDebtorMinuteRequestResolutionDTO>;

  // Columnas de la tabla a mostrar
  public displayedColumns: string[] = [
    'name',
    'buyInvoices',
    'receivedCreditNotes',
    'resolutionStateName'
  ];

  public icons = {
    faCircleMinus, faCircleCheck, faCircleXmark
  };

  constructor(private minuteRequestService: MinuteRequestService,
    private toastrService: ToastrService) {
    this.minuteDebtorResolutions = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.canChangeResolution = false;
  }

  ngOnInit(): void {
    this.setTableDataSource(this.minuteDebtorResolutions);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setTableDataSource(this.minuteDebtorResolutions);
  }

  isLoadingDebtor(companyId: number): boolean {
    return this.loadingDebtors.includes(companyId);
  }

  private setTableDataSource(dataSource: Array<CompanyDebtorMinuteRequestResolutionDTO>){
    this.dataSource = new MatTableDataSource<CompanyDebtorMinuteRequestResolutionDTO>(dataSource);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public toggleDebtorResolutionChange(event: MatButtonToggleChange, companyId: number, currentState: number) {
    this.loadingDebtors.push(companyId);
    const selectedOption = event.value;
    let updateDebtorResolution$: Observable<CompanyDebtorMinuteResolutionDTO> = new Observable<CompanyDebtorMinuteResolutionDTO>;
    switch(selectedOption){
      case 0:
        updateDebtorResolution$ = this.minuteRequestService.pendingDebtorCompanyMinute(companyId, this.minuteRequestId);
        break;
      case 2: 
        updateDebtorResolution$ = this.minuteRequestService.approveDebtorCompanyMinute(companyId, this.minuteRequestId);
        break;
      case 3:
        updateDebtorResolution$ = this.minuteRequestService.rejectDebtorCompanyMinute(companyId, this.minuteRequestId);
        break;
    }

    updateDebtorResolution$
    .pipe(
      finalize(() => {
        this.loadingDebtors = this.loadingDebtors.filter(d => d !== companyId);
      })
    )
    .subscribe({
      error: (err) =>{
        //Revertir estado al estado anterior
        event.source.buttonToggleGroup.writeValue(currentState)      
        this.toastrService.error(err.error?.message || 'Ha ocurrido un error');
      }
    })

  }

}
